// Copyright (c) Mysten Labs, Inc. — DGC: format native CPC amounts
// SPDX-License-Identifier: Apache-2.0

import { useFormatCoin, formatBalance, CoinFormat } from '@mysten/core';
import { Heading, Text } from '@mysten/ui';

import { NATIVE_COIN_TYPE_ARG } from '~/utils/cpcCoin';

type DelegationAmountProps = {
	amount: bigint | number | string;
	isStats?: boolean;
	inMIST?: boolean;
};

export function DelegationAmount({ amount, isStats, inMIST = false }: DelegationAmountProps) {
	const [formattedAmount, symbol] = useFormatCoin(amount, NATIVE_COIN_TYPE_ARG);
	const delegationAmount = inMIST ? formatBalance(amount, 0, CoinFormat.FULL) : formattedAmount;
	const delegationSymbol = inMIST ? 'mist' : symbol;
	return isStats ? (
		<div className="flex items-end gap-1.5 break-all">
			<Heading as="div" variant="heading3/semibold" color="green">
				{delegationAmount}
			</Heading>
			<Heading variant="heading4/medium" color="dark">
				{delegationSymbol}
			</Heading>
		</div>
	) : (
		<div className="flex h-full items-center gap-1">
			<div className="flex items-baseline gap-0.5 break-all">
				<Text variant="body/medium" color="dark">{delegationAmount}</Text>
				<Text variant="subtitleSmall/medium" color="dark">{delegationSymbol}</Text>
			</div>
		</div>
	);
}
